var link_preview_default = {
  "fontElementMap": "_2ejk2",
  "linkPreviewContainer": "YCdKg",
  "linkPreview": "_6ahAY",
  "linkPreviewImage": "fMPmZ",
  "linkPreviewPlaceholder": "Zm8gz",
  "linkPreviewInfo": "L7nqv",
  "linkPreviewTitle": "XwJpF",
  "linkPreviewDescription": "Xc1A3",
  "linkPreviewUrl": "-J5vb",
  "linkPreviewResponsiveImage": "b6-TW",
  "loadingContainer": "wLU9b",
  "errorIcon": "_1hpnS",
  "errorInfo": "S-FlX",
  "errorContainer": "LejDY",
  "overlay": "JJMeZ",
  "thumbnailEnd": "U7HUo",
  "thumbnailStart": "kffMq",
  "thumbnailTop": "xfzrs"
};
export {
  link_preview_default as default
};
//# sourceMappingURL=link-preview-scss.js.map
